var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "center_wrap" },
      [
        _c("div", { staticClass: "wrap_l" }, [
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _c("div", { staticClass: "weituo" }, [
                _c("img", {
                  attrs: { src: require("../../assets/weituo.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tittype" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_entrust_information")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "entrustForm",
                  attrs: {
                    "label-position": "right",
                    "label-width": "80px",
                    size: "small",
                    rules: _vm.entrustInfoRules,
                    model: _vm.entrustInfo
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("i18n_contact_person") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerContact,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerContact",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerContact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("i18n_contact_number") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerTel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerTel",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_entrusting_company")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.namec,
                                  callback: function($$v) {
                                    _vm.$set(_vm.Authorization, "namec", $$v)
                                  },
                                  expression: "Authorization.namec"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { height: "51px" },
                          attrs: { span: 12 }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_pay_party"),
                                prop: "payType"
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.entrustInfo.payType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.entrustInfo, "payType", $$v)
                                    },
                                    expression: "entrustInfo.payType"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: "PP" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("i18n_domestic_payment"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: "CC" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("i18n_foreign_payment"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_warehouse_received_time"),
                                prop: "inWarehouseTime"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  placeholder: _vm.addPls(
                                    "i18n_warehouse_received_time",
                                    "select"
                                  ),
                                  "picker-options": _vm.pickerSetTime
                                },
                                model: {
                                  value: _vm.entrustInfo.inWarehouseTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.entrustInfo,
                                      "inWarehouseTime",
                                      $$v
                                    )
                                  },
                                  expression: "entrustInfo.inWarehouseTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { height: "51px" },
                          attrs: { span: 12 }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_clearance_metods"),
                                prop: "customsClearanceType"
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.entrustInfo.customsClearanceType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.entrustInfo,
                                        "customsClearanceType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "entrustInfo.customsClearanceType"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: "Z" } }, [
                                    _vm._v(_vm._s(_vm.$t("i18n_self_clearing")))
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: "S" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "i18n_Cititran_incharges_of_double_clearing"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_origin_port"),
                                prop: "inWarehouseId"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: _vm.addPls(
                                      "i18n_origin_port",
                                      "select"
                                    )
                                  },
                                  on: { change: _vm.inWarehouseChange },
                                  model: {
                                    value: _vm.entrustInfo.inWarehouseId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.entrustInfo,
                                        "inWarehouseId",
                                        $$v
                                      )
                                    },
                                    expression: "entrustInfo.inWarehouseId"
                                  }
                                },
                                _vm._l(_vm.cangkuLIst, function(item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.namec, value: item.id }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_destination_city"),
                                prop: "toWarehouseId"
                              }
                            },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.WarehouseList,
                                  props: _vm.toWarehouseParams
                                },
                                on: { change: _vm.toWarehouseChange },
                                model: {
                                  value: _vm.entrustInfo.toWarehouseId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.entrustInfo,
                                      "toWarehouseId",
                                      $$v
                                    )
                                  },
                                  expression: "entrustInfo.toWarehouseId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_logistics_services"),
                                prop: "productId"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: _vm.addPls(
                                      "i18n_logistics_services",
                                      "select"
                                    )
                                  },
                                  model: {
                                    value: _vm.entrustInfo.productId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.entrustInfo,
                                        "productId",
                                        $$v
                                      )
                                    },
                                    expression: "entrustInfo.productId"
                                  }
                                },
                                _vm._l(_vm.goodsTypeOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.productName,
                                      value: item.id
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("i18n_Clients_tracking_number")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.customerNo,
                                  callback: function($$v) {
                                    _vm.customerNo = $$v
                                  },
                                  expression: "customerNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                "margin-top": "50px",
                "margin-left": "15px"
              }
            },
            [
              _c("div", { staticStyle: { width: "100%" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { width: "100%", "margin-top": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "100%",
                        background: "#5AB53C",
                        color: "#ffffff"
                      },
                      on: { click: _vm.entrust }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_receive_warehouse_number")))]
                  )
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.$t("i18n_confirmed_enter_warehouse"),
              center: "",
              visible: _vm.dialogTableVisible,
              width: "520px"
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogTableVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "showDalog" }, [
              _c("div", { staticClass: "header_text" }, [
                _c(
                  "div",
                  {
                    staticClass: "count_center",
                    staticStyle: { "margin-right": "50px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "cangkutit",
                        staticStyle: { color: "red" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.inWarehouseInfo.namec) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "ckttext",
                        staticStyle: { "margin-top": "10px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_receving_warehosue")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cangkutit",
                    staticStyle: { "margin-right": "50px" }
                  },
                  [
                    _c("img", {
                      staticStyle: { height: "32px" },
                      attrs: {
                        src: require("../../assets/airOrder.png"),
                        alt: ""
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "count_center" }, [
                  _c(
                    "span",
                    { staticClass: "cangkutit", staticStyle: { color: "red" } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.toWarehouseInfo.namec) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "ckttext",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_destination_city")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "Qdbtn LR_center",
                  staticStyle: { "margin-top": "30px" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "btnstyle",
                      staticStyle: {
                        height: "35px",
                        background: "#ffffff",
                        border: "2px solid #dcdcdc",
                        "border-radius": "35px"
                      },
                      on: {
                        click: function($event) {
                          _vm.dialogTableVisible = false
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("i18n_cancel")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btnstyle",
                      staticStyle: {
                        border: "1px solid #5ab53c",
                        "font-size": "30rpx",
                        background: "#ff3939",
                        "border-color": "#ff3939",
                        color: "#ffffff"
                      },
                      on: { click: _vm.submitOrder }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("i18n_confirm")) +
                          "\n          "
                      )
                    ]
                  )
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.successDialogVisi,
              width: "599px",
              modal: true,
              "close-on-click-modal": false
            },
            on: {
              "update:visible": function($event) {
                _vm.successDialogVisi = $event
              }
            }
          },
          [
            _c("div", { staticClass: "count_center" }, [
              _c("div", { staticClass: "centerCoutn" }, [
                _c(
                  "div",
                  { staticStyle: { width: "100%", "text-align": "center" } },
                  [
                    _c("i", {
                      staticClass:
                        "el-icon-success animate__animated animate__bounceInDown",
                      staticStyle: { "font-size": "55px", color: "#00c300" }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "20px",
                          "font-family": "PingFang SC",
                          "font-weight": "500",
                          color: "#333333",
                          "margin-top": "27px"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("i18n_order_completed")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-family": "PingFang SC",
                          "font-weight": "500",
                          color: "#999999",
                          "margin-top": "8px"
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("i18n_waiting_shipment_to_warehoused")
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "countText" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("i18n_warehouse_number")) +
                            "：" +
                            _vm._s(_vm.orderInfo.innos)
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btnWrap",
                    staticStyle: { width: "100%", "margin-top": "44px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "LR_center",
                        staticStyle: { width: "458px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn1",
                            on: {
                              click: function($event) {
                                return _vm.pathBilltab()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_track_order")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn2",
                            on: {
                              click: function($event) {
                                return _vm.nextSetbill()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_continue_to_order")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn2",
                            on: {
                              click: function($event) {
                                return _vm.labelDownload()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("i18n_download_labels")))]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f66188d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f66188d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/getAirWarehouseNo.vue
// module id = null
// module chunks = 